// @ts-nocheck
import React from 'react';

export default function Doodle({ rule = '', seed = '', ...props }) {
  return (
    <css-doodle seed={seed} {...props}>
      {rule}
    </css-doodle>
  );
}
